import type { FC, ChangeEvent } from 'react';
import { Grid, InputAdornment, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Search from '@mui/icons-material/Search';
import VideosUploader from '../VideosUploader';
import CommonTextField from '@/shared/components/CommonTextField';
import { useGetMeQuery } from '@/editor/services/http/users.api';

interface IVideoHeaderProps {
  tabValue: number;
  onTabChange: (event: any, newValue: number) => void;
  onSearchChange: (value: string) => void;
  mediaLibraryVideosRefetch: () => void;
}

const VideoHeader: FC<IVideoHeaderProps> = ({ tabValue, onTabChange, onSearchChange, mediaLibraryVideosRefetch }) => {
  const { t } = useTranslation();
  const { data: userData } = useGetMeQuery();

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <Grid container>
      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
        <VideosUploader refetchAction={mediaLibraryVideosRefetch} />
        <CommonTextField
          fullWidth={false}
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          onChange={handleSearchInputChange}
        />
      </Grid>

      <Tabs value={tabValue} onChange={onTabChange} centered>
        <Tab label="videos" value={1} />
        {userData?.isVideoGenerationEnabled == true && <Tab label="generatevideos" value={2} />}
      </Tabs>
    </Grid>
  );
};

export default VideoHeader;
